import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_FR: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologie',
  components_header_media_multi_content_2: 'Méditation',
  components_header_media_multi_content_3: 'Amour',
  components_header_text1: 'Guides',
  components_header_text2: 'Blog',
  hero_text: 'Trouvez la clarté, l\'équilibre et le lien.',
  hero_button_text: 'Commencez votre voyage',
  components_ressources_subheader_text: 'Conseils et inspiration',
  components_ressources_span_text: 'Elle combine des éclairages astrologiques personnels, des pratiques de méditation apaisantes et des conseils amoureux bienveillants pour favoriser la découverte de soi, l\'équilibre émotionnel et une connexion plus profonde.',
  components_ressources_card_1_title: 'Conseils de méditation',
  components_ressources_card_1_text: 'Guide rapide pour mieux se calmer, respirer et se concentrer.',
  components_ressources_card_2_title: 'Conseils amoureux',
  components_ressources_card_2_text: 'Des conseils simples pour renforcer les liens et trouver un équilibre émotionnel.',
  components_ressources_link: 'Découvrez-en plus',
  components_notes_and_google_title_1: 'Trouver la clarté',
  components_notes_and_google_title_2: 'Calme intérieur',
  components_notes_and_google_title_3: 'Connexion du cœur',
  media_content_section_multi_1_subheader_text: 'Notre podcast',
  media_content_section_multi_2_subheader_text: 'Nos méditations',
  media_content_section_multi_3_subheader_text: 'Parlons franchement de romance cosmique',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'pleine conscience',
  page_media_content_menu_energyboost: 'Coup de fouet énergétique',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Fondations',
  page_media_content_menu_spirituality: 'Spiritualité',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psychologie',
  page_media_content_menu_trends: 'Tendances',
  page_media_content_menu_compatibility: 'Compatibilité',
  page_media_content_menu_love: 'Amour',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles et analyses',
  text2_section_button_more: 'Charger plus',
  components_text1_section_title: 'GUIDES',
  components_text1_subheader_text: 'Connaissance cosmique pour un alignement quotidien',
  components_text1_span_text: 'Harmonisez-vous avec les rythmes de l\'univers : explorez une collection soigneusement sélectionnée de guides astrologiques et méditatifs approfondis, conçus pour éveiller la clarté intérieure, approfondir la conscience de soi et soutenir votre cheminement vers une croissance spirituelle et céleste.',
  components_text1_card_1_title: 'Ouvert au calme',
  components_text1_card_1_text: 'Commencez votre voyage par des guides fondamentaux de méditation et d\'astrologie – idéaux pour les chercheurs attirés par le calme intérieur, les schémas cosmiques et la connaissance de soi.',
  components_text1_card_3_title: 'Lien corps-esprit',
  components_text1_card_3_text: 'Explorez les profondeurs de votre monde intérieur. Ces guides vont au-delà des apparences pour révéler le sens, les émotions et les schémas de pleine conscience qui façonnent votre expérience.',
  components_text1_card_2_title: 'Réfléchir et intégrer',
  components_text1_card_2_text: 'Des blocages émotionnels aux cycles planétaires, ces guides offrent des outils de réflexion, de guérison et de transformation grâce à des rituels de pleine conscience et à la sagesse astrologique.',
  components_text1_link: 'Voir tous les guides',
  components_footer_text: 'Trouvez la clarté, équilibrez votre esprit et connectez-vous au sens – votre espace dédié à l\'astrologie, à la méditation et à l\'amour.',
};